import Layout from 'base/layouts/Layout';

import { MENU_ORDER_SETTING, MENU_ITEM_DETAIL } from 'menus/constants/paths';

import OrderSettingModal from 'menus/containers/OrderSettingModal';
import MenuItemDetailModal from 'menus/containers/MenuItemDetailModal';

const routes = [
  {
    path: MENU_ORDER_SETTING,
    exact: true,
    Component: OrderSettingModal,
    Layout: Layout
  },
  {
    path: MENU_ITEM_DETAIL,
    exact: true,
    Component: MenuItemDetailModal,
    Layout: Layout
  }
];

export default routes;
